import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { Heading1, TextDefault, FlexDiv } from '@awarego-ui/components';
import styles from './summary.module.scss';
import { calculateColor } from '../../../utils/helpers';

function Summary({
    mainNumberText,
    mainNumber,
    secondaryNumberText,
    secondaryNumber,
    iconUrl,
    iconAlt,
    item,
    // For completion rate display (assessment insights)
    completionRate,
    usersFinished,
    usersTotal,
}) {
    const tab = mainNumberText.toLowerCase();
    const showCompletionRate = completionRate !== undefined;

    return (
        <Link
            to={`/${item}/${tab}`}
            className={styles['summary']}
            style={{ marginRight: '16px', marginLeft: '16px' }}
        >
            <div
                className={classnames(
                    styles['summary-section'],
                    styles['summary-section-border-bottom']
                )}
            >
                <FlexDiv column>
                    <TextDefault>{mainNumberText}</TextDefault>
                    <Heading1>{mainNumber}</Heading1>
                </FlexDiv>
                <img src={iconUrl} alt={iconAlt} />
            </div>
            <div className={styles['summary-section']}>
                {showCompletionRate ? (
                    <>
                        <TextDefault lighter>Completion rate</TextDefault>
                        <div className={styles['summary-section-line']}>
                            <img src="/static/img/icon-person.svg" alt="person" />
                            <TextDefault bold>{usersFinished} / {usersTotal}</TextDefault>
                        </div>
                        <TextDefault bold color={calculateColor(completionRate)}>
                            {completionRate}%
                        </TextDefault>
                    </>
                ) : (
                    <>
                        <TextDefault lighter>{secondaryNumberText}</TextDefault>
                        <div className={styles['summary-section-line']}>
                            <img src="/static/img/icon-person.svg" alt="person" />
                            <TextDefault bold>{secondaryNumber}</TextDefault>
                        </div>
                    </>
                )}
            </div>
        </Link>
    );
}

export default Summary;
